import firebase from 'firebase/app'
import moment from 'moment-timezone'
import { api } from '@jessicarobins/lineaday'

const locale = window.navigator.language
const timezone = moment.tz.guess()
const userApi = api.user(firebase, { locale, timezone })

export default userApi
